import { Link } from 'react-router-dom';
import { categories, aboutInfo } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 no-underline">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg text-sm font-bold">
                漫
              </span>
              <span className="text-lg font-heading font-bold text-background-50 whitespace-nowrap">
                无遮韩国免费漫画大全
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              {aboutInfo.tagline}。我们提供最全面的韩漫资源，全部免费在线阅读，网站稳定性高，更新速度快。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              漫画分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(1, 7).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              热门推荐
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/article/101" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline">
                  2026年十大韩漫推荐
                </Link>
              </li>
              <li>
                <Link to="/article/102" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline">
                  韩漫入门指南
                </Link>
              </li>
              <li>
                <Link to="/article/103" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline">
                  我独自升级完结回顾
                </Link>
              </li>
              <li>
                <Link to="/article/104" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline">
                  恋爱韩漫推荐
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-heading font-semibold text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline">
                  品牌介绍
                </Link>
              </li>
              <li>
                <a href={`mailto:${aboutInfo.contact.email}`} className="text-sm text-background-50/60 hover:text-background-50 transition-colors no-underline">
                  联系我们
                </a>
              </li>
              <li>
                <span className="text-sm text-background-50/60">
                  客服电话：{aboutInfo.contact.phone}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 无遮韩国免费漫画大全. 保留所有权利.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors no-underline" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors no-underline" rel="nofollow">
              服务条款
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors no-underline" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}